import React, { useEffect, useState } from "react";
import { HelpCircle } from "lucide-react";
import "./iplbattle.css";
import ipl from "../../../assets/ipl/IPLWAR.svg";
import { IplTeamList } from "../../../apis/iplBattle";
import useUserInfo from "../../../Hooks/useUserInfo";
import Swal from "sweetalert2";
import ComboScreen from "./combo";
import { logPageView } from "../../../components/analytics";
import { logoMap2, getTeamColorsByLeague } from "../../../helpers/helpers";

const ChooseIplTeam = () => {
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [haterTeam, setHaterTeam] = useState(null);
  const [selectionMode, setSelectionMode] = useState("favorite"); // 'favorite' or 'hater'
  const [IplTeam, setIplTeam] = useState([]);
  const [IsError, setError] = useState("");
  const { userDetails, watchScreen, updatewatchScreenInfo, updateUserInfo } =
    useUserInfo();
    const IsTBD = process.env.REACT_APP_IS_TBD_ID;
  const [favTeam, setFavTeam] = useState({
    teamName: "",
    teamLogo: "",
    id: "",
  });
  const [hateTeam, setHateTeam] = useState({
    teamName: "",
    teamLogo: "",
    id: "",
  });

  const [openPopup, setOpenPopup] = useState(false);
  const handleSelectTeam = (teamName, teamLogo, id) => {
    if (!favTeam?.teamName) {
      setFavTeam({ teamName: teamName, teamLogo: teamLogo, id: id });
    } else {
      setHateTeam({
        teamName: teamName,
        teamLogo: teamLogo,
        id: id,
      });
    }
  };
  console.log(favTeam, "fave", hateTeam, "hateTeam");

  useEffect(() => {
    logPageView("UFW CHOOSE PAGE", "UFW CHOOSE PAGE");
  }, []);

  useEffect(() => {
    const fetchTeam = async () => {
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: true,
      }));
      const result = await IplTeamList(watchScreen?.cricketLeague);
      console.log(result, "result");

      if (result) {
        //This filter change was made for playoffs TBD
        setIplTeam(result.teams?.filter((el)=>el?._id!=IsTBD));
      } else {
        setError(result.error);
      }

      updateUserInfo((prev) => ({
        ...prev,
        isLoading: false,
      }));
    };

    fetchTeam();
  }, []);
  const handleChangeTeam = (team) => {
    if (team == "Fav" && favTeam?.teamName == "") {
      alert("Choose your Like Team!");
    } else if (team == "Hate" && hateTeam?.teamName == "") {
      alert("Choose your Dislike Team!");
    } else {
      Swal.fire({
        // title: "Are you sure?",
        text: ` Are you sure, Do you want to change your ${
          team == "Fav" ? "Like" : "DisliKe"
        } team?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        reverseButtons: true, // Puts "Exit" on the left and "Continue" on the right
      }).then((result) => {
        if (result.isConfirmed && team == "Fav") {
          setFavTeam({ teamName: "", teamLogo: "", id: "" });
        } else if (result.isConfirmed && team == "Hate") {
          setHateTeam({ teamName: "", teamLogo: "", id: "" });
        }
      });
    }
  };
  var data = {
    favouriteTeamId: favTeam?.id, // Ensure field matches schema
    hatedTeamId: hateTeam?.id,
    category: watchScreen?.cricketLeague,
  };
  const handleContinue = async () => {
    setOpenPopup(true);

    //  ChooseFavHateTeam(data);
  };
  return (
    <>
      <div
        className={openPopup ? "blur-background" : ""}
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          flexDirection: "column",
          marginTop: "50px",
          pointerEvents: "fill",
        }}
      >
        <div className="row flex">
          <div className="col-12">
            <div
              className="bg-logo"
              style={{
                textAlign: "center",
                // padding: "8px",
                //   marginBottom: "8px",
                //   background: "#121212",
                //   borderBottom: "2px solid #0f0",
              }}
            >
              <img
                style={{ marginTop: "15px", marginBottom: "10px" }}
                src="https://d1ccopf5cw1hft.cloudfront.net/s3data/fanwarlogo.png"
              />
            </div>
            <div className="row justify-center">
              <div className="col-12 battlebg">
                {/* Selection prompt */}
                <div
                  style={{
                    textAlign: "center",
                    padding: "8px",
                    marginBottom: "8px",
                    background: "#121212",
                  }}
                >
                  <h5
                    className="sub-head"
                    style={{ color: "#0f0", marginBottom: "0px" }}
                  >
                    CHOOSE YOUR COMBO!
                  </h5>
                </div>

                {/* Team Selection Area */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    margin: "10px 0px",
                    paddingLeft: "12px",
                    paddingRight: "12px",
                  }}
                >
                  {/* Favorite Team */}
                  <div
                    onClick={() => handleChangeTeam("Fav")}
                    style={{
                      borderRadius: "2px",
                      padding: "15px",
                      background: "#121212",
                      border: favTeam?.teamName
                        ? `1px solid #018125`
                        : "1px solid transparent",
                      backgroundImage: favTeam?.teamName
                        ? "none"
                        : "linear-gradient(#002E03, #002E03), linear-gradient(45deg, #000000, #333333)",
                      backgroundOrigin: "border-box",
                      backgroundClip: "padding-box, border-box",
                      textAlign: "center",
                      position: "relative",
                      cursor: "pointer",
                      width: "35%",
                      height: "100px",
                    }}
                  >
                    {favTeam?.teamName && (
                      <div>
                        <p className="change-fav">change</p>
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                      }}
                    >
                      {favTeam?.teamName && <div className="rotateipl"></div>}
                      <div style={{ color: "#0f0" }}>
                        <img
                          style={{
                            width: favTeam?.teamName ? "50px" : "60px",
                          }}
                          src={
                            favTeam?.teamLogo
                              ? favTeam?.teamLogo
                              : `https://d1ccopf5cw1hft.cloudfront.net/s3data/fvrt.svg`
                          }
                        />
                        {favTeam?.teamName && (
                          <h4 className="fans-text1">{favTeam?.teamName}</h4>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* VS */}
                  {/* <div style={{ display: "flex", alignItems: "center" }}>
                    <span
                      style={{
                        color: "#727272",
                        fontSize: "14px",
                        fontFamily: "press",
                      }}
                    >
                      VS
                    </span>
                  </div> */}

                  {/* Hater Team */}
                  <div
                    onClick={() => handleChangeTeam("Hate")}
                    style={{
                      borderRadius: "2px",
                      padding: "15px",
                      background: "#121212",
                      border: hateTeam?.teamName
                        ? `1px solid #FF2B2B`
                        : "1px solid transparent",
                      backgroundImage: hateTeam?.teamName
                        ? "none"
                        : "linear-gradient(#2F0101, #2F0101), linear-gradient(45deg, #000000, #333333)",
                      backgroundOrigin: "border-box",
                      backgroundClip: "padding-box, border-box",
                      textAlign: "center",
                      position: "relative",
                      cursor: "pointer",
                      width: "35%",
                      height: "100px",
                    }}
                  >
                    {hateTeam?.teamName && (
                      <div>
                        <p className="change-hate">change</p>
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                      }}
                    >
                      {hateTeam?.teamName && <div className="rotateipl"></div>}
                      <div
                        // className={hateTeam?.teamName ? "battle" : ""}
                        style={{ color: "#0f0" }}
                      >
                        <img
                          style={{
                            width: hateTeam?.teamName ? "50px" : "60px",
                          }}
                          src={
                            hateTeam?.teamLogo
                              ? hateTeam?.teamLogo
                              : `https://d1ccopf5cw1hft.cloudfront.net/s3data/hated.svg`
                          }
                        />
                        {hateTeam?.teamName && (
                          <h4 className="fans-text1">{hateTeam?.teamName}</h4>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Team label */}
                <div
                  style={{
                    textAlign: "center",
                    background: "#1b1b1b",
                    padding: "5px",
                    marginBottom: "12px",
                    marginTop: "12px",
                  }}
                >
                  <span
                    className="text-uppercase"
                    style={{
                      color: "#828282",
                      fontSize: "14px",
                      letterSpacing: "1px",
                    }}
                  >
                    Select Team
                  </span>
                </div>

                {/* Team Grid */}
                <div>
                  <div
                    style={{
                      // display: "flex",
                      flexWrap: "wrap",
                      gap: "8px",
                      justifyContent: "center",
                    }}
                  >
                    <div className="row" style={{ padding: "0px 10px" }}>
                      <div
                        className={`ipl-board ${
                          favTeam?.teamName && hateTeam?.teamName
                            ? "ipl-boardscroll"
                            : "null"
                        }`}
                      >
                        {IplTeam?.map((el, index) => {
                          const isDisabled =
                            favTeam?.teamName == el?.teamName ||
                            hateTeam?.teamName == el?.teamName;

                          const teamColor = getTeamColorsByLeague(el?.teamName, watchScreen?.cricketLeague);
                          console.log(el?.teamName, "teamColor");
                          

                          return (
                            <>
                              <div
                                className="battle "
                                style={{
                                  border:
                                    favTeam?.teamName == el?.teamName
                                      ? "1px solid green"
                                      : hateTeam?.teamName == el?.teamName
                                      ? "1px solid red"
                                      : "",
                                  pointerEvents: isDisabled ? "none" : "auto",
                                }}
                                onClick={() =>
                                  handleSelectTeam(
                                    el?.teamName,
                                    el?.teamLogo,
                                    el?._id
                                  )
                                }
                              >
                                <div className="battleflex">
                                  <img className="img-ipl" src={el?.teamLogo} />
                                </div>
                                <h3
                                  className="fans-text"
                                  style={{
                                    background: teamColor?.background || "#333333",
                                    color: "#ffffff",
                                  }}
                                >
                                  {el?.teamName}
                                </h3>
                              </div>
                            </>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {favTeam?.teamName && hateTeam?.teamName && (
                <div
                  className="battle-con"
                  style={{
                    opacity: 1,
                    transform: "translateY(0)",
                    transition: "all 0.2s ease-out",
                    zIndex: "1",
                  }}
                >
                  <button onClick={handleContinue}>Continue</button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {openPopup && (
        <ComboScreen
          setOpenPopup={setOpenPopup}
          data={data}
          favTeam={favTeam}
          hateTeam={hateTeam}
        />
      )}
    </>
  );
};

export default ChooseIplTeam;
